import React, { useMemo } from 'react';
import { Icon } from '@shakkerai/components';
import { useModelsModalState, setModelsModalState } from '../../../../store/state';
import cs from 'classnames';

const jump = (list, item, idx, menus, setMenus) => {
  // TODO 有时间就抽留下
  if (list.length - 1 === idx) return;
  let newMenu = [...menus].map((m) => ({
    ...m,
    choosed: m.id === item.id,
    children: (m.children ?? []).map((m) => ({
      ...m,
      choosed: m.id === item.id,
      children: (m.children ?? []).map((m) => ({
        ...m,
        choosed: m.id === item.id,
      })),
    })),
  }));
  setMenus(newMenu);
  setModelsModalState({
    collectState: {},
  });
};

const Bread = ({ menuPath, menus, setMenus }) => {
  const collectState = useModelsModalState('collectState');
  const list = useMemo(() => {
    const _path = [];
    // 在12级菜单中额外形成的bread数据
    if (collectState.data) {
      if (collectState.menuPath.level === 0) {
        _path.push(collectState.menuPath.menu);
        _path.push({ tagLabel: collectState.data.title });
      }
      if (collectState.menuPath.level === 1) {
        (collectState.menuPath.menu.children ?? []).forEach((p) => {
          if (p.choosed) {
            _path.push(collectState.menuPath.menu);
            _path.push(p);
            _path.push({ tagLabel: collectState.data.title });
          }
        });
      }
      if (collectState.menuPath.level === 2) {
        (collectState.menuPath.menu.children ?? []).forEach((p) => {
          (p.children ?? []).forEach((c) => {
            if (c.choosed) {
              _path.push(collectState.menuPath.menu);
              _path.push(p);
              _path.push(c);
              _path.push({ tagLabel: collectState.data.title });
            }
          });
        });
      }
      // 标准123级菜单数据形成的bread数据
    } else {
      (menuPath.menu.children ?? []).forEach((p) => {
        (p.children ?? []).forEach((c) => {
          if (c.choosed) {
            _path.push(menuPath.menu);
            _path.push(p);
            _path.push(c);
          }
        });
      });
    }
    return _path;
  }, [menuPath.level, menuPath.menu, collectState.data, collectState.menuPath]);
  return (
    <div className="flex mt-2">
      {list.map((item, idx) => {
        return (
          <div id={item.id} className="flex" key={idx}>
            <span
              onClick={() => jump(list, item, idx, menus, setMenus)}
              className={cs(list.length - 1 !== idx ? 'text-[#2b2b2b] cursor-pointer' : 'text-[#009DFF]')}
            >
              {item.tagLabel}
            </span>
            {idx !== list.length - 1 && (
              <Icon className="ml-1 shk-kuangjia-xiala -rotate-90 block" fontSize={18} color="inherit" />
            )}
          </div>
        );
      })}
    </div>
  );
};
export default Bread;
